export function formatMsToHrs (Time) {
	return function (ms, includeUnits) {
		let hours = Time.millisecondsToHrs(ms);
		return hours += includeUnits ? ' hr' + (hours === 1 ? '' : 's') : '';
	};
}
